import { Input } from 'antd';
import React, { useCallback, useState } from 'react';
import { TextAreaProps } from 'antd/lib/input';

interface ISingleLineTextArea {
  initialValue?: string;
  onChange?: (value: string) => void;
}

const SingleLineTextArea = ({
  placeholder,
  initialValue,
  onChange,
  maxLength,
  size,
  style,
}: TextAreaProps & ISingleLineTextArea) => {
  const [value, setValue] = useState(initialValue || '');

  const onKeyDown = useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }, []);

  const onChangeInput = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const resultValue = e.target.value.replaceAll('\n', '');

      setValue(resultValue);
      onChange?.(resultValue);
    },
    [onChange],
  );

  return (
    <Input.TextArea
      autoSize={{ minRows: 1, maxRows: 3 }}
      placeholder={placeholder}
      value={value}
      onChange={onChangeInput}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
      style={style}
      size={size}
    />
  );
};
export default SingleLineTextArea;
